'use strict';

require('./global-status.model.js');

